/*
 *
 * UserManagement constants
 *
 */

export const DEFAULT_ACTION = 'app/UserManagement/DEFAULT_ACTION';

export const FETCH_USERS = 'app/UserManagement/FETCH_USERS';
export const FETCH_USERS_SUCCESS = 'app/UserManagement/FETCH_USERS_SUCCESS';
export const FETCH_USERS_FAILURE = 'app/UserManagement/FETCH_USERS_FAILURE';

export const CREATE_USER = 'app/UserManagement/CREATE_USER';
export const CREATE_USER_SUCCESS = 'app/UserManagement/CREATE_USER_SUCCESS';
export const CREATE_USER_FAILURE = 'app/UserManagement/CREATE_USER_FAILURE';

export const SET_ACTIVATION_STATUS = 'app/UserManagement/SET_ACTIVATION_STATUS';
export const ACTIVATE_USER_SUCCESS = 'app/UserManagement/ACTIVATE_USER_SUCCESS';
export const ACTIVATE_USER_FAILURE = 'app/UserManagement/ACTIVATE_USER_FAILURE';
export const DEACTIVATE_USER_SUCCESS =
  'app/UserManagement/DEACTIVATE_USER_SUCCESS';
export const DEACTIVATE_USER_FAILURE =
  'app/UserManagement/DEACTIVATE_USER_FAILURE';

export const START_IMPORT_USERS = 'app/UserManagement/START_IMPORT_USERS';
export const START_IMPORT_USERS_SUCCESS =
  'app/UserManagement/START_IMPORT_USERS_SUCCESS';
export const START_IMPORT_USERS_FAILURE =
  'app/UserManagement/START_IMPORT_USERS_FAILURE';

export const COMPLETE_IMPORT_USERS = 'app/UserManagement/COMPLETE_IMPORT_USERS';
export const COMPLETE_IMPORT_USERS_SUCCESS =
  'app/UserManagement/COMPLETE_IMPORT_USERS_SUCCESS';
export const COMPLETE_IMPORT_USERS_FAILURE =
  'app/UserManagement/COMPLETE_IMPORT_USERS_FAILURE';

export const RESET_IMPORT_FILE = 'app/UserManagement/RESET_IMPORT_FILE';

export const CHANGE_PAGINATION = 'app/UserManagement/CHANGE_PAGINATION';

export const DEFAULT_FETCH_USERS_LIMIT = 15;

export const RESET_STATE = 'app/UserManagement/RESET_STATE';
